import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from './index';
import { COLORS } from '../color';
var ButtonIconTerminal = function (_a) {
    var iconPath = _a.iconPath, title = _a.title, className = _a.className, disabled = _a.disabled, onClick = _a.onClick, href = _a.href, to = _a.to, id = _a.id, _b = _a.iconSize, iconSize = _b === void 0 ? 'md' : _b, isNoBorder = _a.isNoBorder, isFilled = _a.isFilled;
    var buttonIconTerminalSize = iconSize === 'md' ? 32 / 24 : 2.5;
    var renderContent = useMemo(function () {
        var classNameResult = 'button-icon-terminal ' + (iconSize + ' ') + (disabled ? 'disabled ' : '') + (isNoBorder ? 'no-border no-shadow ' : '') + (isFilled ? 'filled ' : '');
        var iconContent;
        var icon = React.createElement(Icon, { path: iconPath, size: buttonIconTerminalSize, color: COLORS.gray700 });
        if (href) {
            iconContent = (React.createElement("a", { href: disabled ? undefined : href, className: classNameResult, id: id, title: title, onClick: onClick }, icon));
        }
        else if (to) {
            iconContent = (React.createElement(Link, { to: disabled ? undefined : to, className: classNameResult, id: id, title: title }, icon));
        }
        else {
            iconContent = (React.createElement("button", { type: 'button', id: id, className: classNameResult, title: title, onClick: onClick, disabled: disabled }, icon));
        }
        return (React.createElement("span", { className: 'd-flex justify-content-center align-items-center ' + (className ? className : '') }, iconContent));
    }, [className, disabled, href, iconPath, id, onClick, title, to]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { ButtonIconTerminal };
//# sourceMappingURL=ButtonIconTerminal.js.map